import { BaseService } from "./BaseService";

export const ElementoPrimarioGenericoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elementos-primarios-genericos/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos elementos primários genéricos:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`elementos-primarios-genericos/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do elemento primário genérico:', error);
            return false;
        }
    },
    async getAnosOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('elementos-primarios-genericos/options/anos');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de anos:', error);
            return false;
        }
    },
}

